<template>
    <v-form-item
        name="replyAppletPlugin"
        label="小程序卡片"
        required="请选择"
        :rules="rules"
        @error="handlerError"
    >
        <div class="applet-selector-box">
            <common-material-select
                ref="miniProgramBtn"
                @confirm="handlerAppletPickerOk"
                :multiple="false"
                :fetchFunc="fetchApplet"
                :value="[currentValue]"
                material-type="miniProgram"
                class="applet-selector"
            >
                <template slot="selector-box">
                    <v-input
                        :value="showContent"
                        :clearable="false"
                        name="replyAppletPlugin"
                        placeholder="请选择"
                        readonly
                        class="applet-plugin-trigger"
                    >
                        <template slot="right-icon">
                            <v-icon
                                name="arrow_down_small_line"
                                remote
                            />
                        </template>
                    </v-input>
                </template>
            </common-material-select>
            <template v-if="showContent">
                <v-button
                    v-tip:appletPreview.hover
                    type="link"
                    kind="primary"
                >
                    预览
                </v-button>
                <v-tip
                    ref="appletPreview"
                    placement="top-end"
                >
                    <appletCard :item="currentValue" />
                </v-tip>
            </template>
        </div>
    </v-form-item>
</template>

<script>
import appletCard from './applet-card';
import errorMixin from '../errorMixin';

export default {
    mixins: [errorMixin],
    components: {
        CommonMaterialSelect: (r) => {
            window._rhinoComponents.marketRequire('common-material-select', '0.0.1').then((res) => {
                r(res);
            });
        },
        appletCard,
    },
    props: {
        value: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            currentValue: this.value || {},
            rules: [{
                validate: (val, rule) => {
                    return this.$ajax.get(`/ea/material/miniPrograms/detail?id=${this.currentValue.materialId}`)
                        .then((res) => {
                            if (res.code !== 0) { // 素材已被删除，code=100
                                throw new Error(rule.message);
                            }

                            return true
                        });
                },
                message: '素材已被删除，请重新选择',
                trigger: 'input,submit',
            }],
        };
    },
    computed: {
        showContent() {
            return (this.currentValue && this.currentValue.appName) || '';
        },
    },
    watch: {
        value(val) {
            this.currentValue = val;
        },
        currentValue(val) {
            this.$emit('input', val);
        },
    },

    methods: {
        chooseImg() {
            this.isShowSelectPanel = true;
        },

        // 拉去小程序插件列表
        fetchApplet(params, _this) {
            // 全部分组 && 无搜索关键词 = 全数据
            if (params.level === '0' && !params.searchKey) {
                return this.$ajax.get(params.groupUrl, { params: { type: params.type } })
                    .then((res) => {
                        if (res.code === 0) {
                            // 素材的其他分组
                            if (res.data.records) {
                                res.data.records.forEach((item) => {
                                    item.level = 1;
                                    item.label = item.name;
                                });
                            }
                        }
                        return {
                            options: (res.data.records || res.data.groups) || [],
                            total: res.data.total || 0,
                        };
                    });
            }
            const { count, page, searchKey, id, status, available } = params;
            const ids = id && id !== 0 ? id : (id === 0 ? 0 : -1);
            return this.$ajax.get(params.url, { params: { count, keyword: searchKey || undefined, startTime: '', groupId: ids, status, index: page, name: '', available: available || undefined } })
                .then((res) => {
                    if (_this.props && _this.props(_this).formatterResult) {
                        _this.props(_this).formatterResult(res.data);
                    }
                    return {
                        options: res.data.records || [],
                        total: res.data.total || 0,
                    };
                });
        },

        // 确认选择
        handlerAppletPickerOk(val) {
            this.currentValue = val[0];
        },
    },
};
</script>

<style lang="less" scoped>
.applet-selector-box{
    margin-top: -6px;
    display: flex;
    align-items: center;
}
.applet-selector{
    background: #fff;
    flex: 1;
    margin-right: var(--spacing-base);

    /deep/.select-box-slot{
        width: 100%;
        .common-select-plus-box{
            width: 100%;
        }
    }
}

.applet-plugin-trigger{
    width: 100%;
    margin-top: 0 !important;
    cursor: pointer;
    /deep/input{
        cursor: pointer;
    }
    margin-right: var(--spacing-base);

    .v-icon{
        color: var(--color-text-caption);
    }
}
</style>
